// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';

// その他のページ
import Garden from './pages/features/Garden';
import GardenEn from './pages/features/GardenEn';
import Craft from './pages/features/Craft';
import CraftEn from './pages/features/CraftEn';
import Machiya from './pages/features/Machiya';
import MachiyaEn from './pages/features/MachiyaEn';
import Renovation from './pages/features/Renovation';
import RenovationEn from './pages/features/RenovationEn';
import PrimeLocation from './pages/features/PrimeLocation';
import PrimeLocationEn from './pages/features/PrimeLocationEn';
import SpecialOfferPage from './components/SpecialOfferPage';
import LegalNoticePage from './components/LegalNoticePage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import AgreementPage from './components/AgreementPage';
import ContactPage from './components/ContactPage';
import GuestConcierge from './components/GuestConcierge';
import ZenWalkPage from './pages/ZenWalkPage';


// ▼ 名前を変更した社内テスト用ページを読み込み
import InternalTestExperiencesPage from './components/InternalTestExperiencesPage';

// 予約ページ
import BookingPage from './pages/BookingPage';
import BookingLookup from './components/BookingLookup';
import FAQ from './pages/FAQ';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />}>

            <Route index element={<Home />} />
            <Route path="en" element={<Home />} />

            {/* 予約ページ */}
            <Route path="booking" element={<BookingPage />} />
            <Route path="en/booking" element={<BookingPage />} />

            {/* ▼▼▼ この2行を追加（大文字でも BookingPage を表示する） ▼▼▼ */}
            <Route path="Booking" element={<Navigate to="/booking" replace />} />
            <Route path="en/Booking" element={<Navigate to="/en/booking" replace />} />

            <Route path="lookup" element={<BookingLookup />} />
            <Route path="en/lookup" element={<BookingLookup />} />

            {/* その他のページ */}
            <Route path="features/garden" element={<Garden />} />
            <Route path="en/features/garden" element={<GardenEn />} />
            <Route path="features/craft" element={<Craft />} />
            <Route path="en/features/craft" element={<CraftEn />} />
            <Route path="features/machiya" element={<Machiya />} />
            <Route path="en/features/machiya" element={<MachiyaEn />} />
            <Route path="features/renovation" element={<Renovation />} />
            <Route path="en/features/renovation" element={<RenovationEn />} />
            <Route path="features/primelocation" element={<PrimeLocation />} />
            <Route path="en/features/primelocation" element={<PrimeLocationEn />} />
            <Route path="terms" element={<LegalNoticePage />} />
            <Route path="en/terms" element={<LegalNoticePage />} />
            <Route path="privacy" element={<PrivacyPolicyPage />} />
            <Route path="en/privacy" element={<PrivacyPolicyPage />} />
            <Route path="rules" element={<AgreementPage />} />
            <Route path="en/rules" element={<AgreementPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="en/contact" element={<ContactPage />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="en/faq" element={<FAQ />} />

            {/* ─── 本番公開用（SEO対象） ─── */}
            <Route path="special-offer" element={<SpecialOfferPage />} />
            <Route path="en/special-offer" element={<SpecialOfferPage />} />

            {/* ─── 社内確認・テスト用（SEO除外） ─── */}
            {/* URLも /internal-test に変更 */}
            <Route path="internal-test" element={<InternalTestExperiencesPage />} />
            <Route path="en/internal-test" element={<InternalTestExperiencesPage />} />

            {/* ─── 旧URLからのリダイレクト（後方互換） ─── */}
            <Route path="specialoffer" element={<Navigate to="/special-offer" replace />} />
            <Route path="en/specialoffer" element={<Navigate to="/en/special-offer" replace />} />

            {/* 過去の社内用URLにアクセスした場合は新しいテスト用URLへ飛ばす */}
            <Route path="SpecialExperiencesPage" element={<Navigate to="/internal-test" replace />} />
            <Route path="en/SpecialExperiencesPage" element={<Navigate to="/en/internal-test" replace />} />
            <Route path="special-experiences" element={<Navigate to="/internal-test" replace />} />
            <Route path="en/special-experiences" element={<Navigate to="/en/internal-test" replace />} />

            <Route path="zen-hondamachi" element={<ZenWalkPage />} />
            <Route path="en/zen-hondamachi" element={<ZenWalkPage />} />

          </Route>

          {/* 宿泊者専用：館内掲示のQRコードからのみ誘導 */}
          <Route path="/welcome-akebono" element={<GuestConcierge />} />



        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;